"use client";

import { Img } from "@/components/Img";
import {
  getClientSideCookieValue,
  getDefaultLang,
  isTvEnv,
} from "@/utils/common.helpers";
import Link from "next/link";
import logoSquare from "../../public/images/stage.png";
import {
  AppRoutesEnum,
  CookiesEnum,
  cookiesValues,
} from "@/constants/constants";
import { useClientTranslations } from "@/hooks/useClientTranslations";

export const Logo = ({
  wrapInLink = true,
  large = false,
  medium = false,
}: {
  wrapInLink?: boolean;
  large?: boolean;
  medium?: boolean;
}) => {
  const WrapperElement = wrapInLink ? Link : "div";
  const tempCulture = getClientSideCookieValue(
    cookiesValues[CookiesEnum.TempCulture],
  );

  // Use client translations on client side, fallback to getDefaultLang on server
  const { currentLanguage } = useClientTranslations();
  const lang = currentLanguage || getDefaultLang();

  // if tempCulture is set, redirect to tempCulture home page
  // ref: https://stagedotin.slack.com/archives/D09C9B39P54/p1760523158116249
  const redirectUrl = tempCulture
    ? `/${lang}/${tempCulture}`
    : AppRoutesEnum.COMMON_HOME;
  return (
    <WrapperElement
      href={redirectUrl}
      className={`logo-container ${
        isTvEnv() ? "!w-[110px]" : ""
        // hardcoding heigth width as aspect ratio css is not supported in tv
      } ${large ? "!h-[120px] !w-[200px]" : ""} ${medium ? "!h-[40px] !w-[154px]" : ""}`}
      data-testid="logo"
    >
      <Img
        src={`${process.env.NEXT_PUBLIC_CDN_ROOT_URL}/static/stage_logo_horizontal.webp`}
        alt="Logo"
        className="logo"
        fill={true}
        sizes="6.5rem"
      />
    </WrapperElement>
  );
};

export const LogoSquare = ({
  hideOnMobile = false,
}: {
  hideOnMobile?: boolean;
}) => {
  return (
    <Img
      src={logoSquare}
      alt="Logo"
      className={`logo aspect-square ${hideOnMobile ? "hidden md:block" : ""}`}
      height={80}
      width={80}
      sizes="5rem"
    />
  );
};

export const LogoStack = ({
  width = 40,
  height = 40,
  className = "",
}: {
  width?: number;
  height?: number;
  className?: string;
}) => {
  return (
    <Img
      src={`${process.env.NEXT_PUBLIC_CDN_ROOT_URL}/static/stage_logo_stack.png`}
      alt="Stage Logo"
      width={width}
      height={height}
      className={className}
    />
  );
};
